import { render } from "./ProjectsCard.vue?vue&type=template&id=8cc059d6&scoped=true"
import script from "./ProjectsCard.vue?vue&type=script&lang=js"
export * from "./ProjectsCard.vue?vue&type=script&lang=js"

import "./ProjectsCard.vue?vue&type=style&index=0&id=8cc059d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc059d6"]])

export default __exports__